import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { MsalProvider } from '@azure/msal-react';
import './App.css';
import Root from './Root.js';
import { AuthProvider } from "./authProvider.js";
import GlobalRouteHighlighter from './Components/common/Banner/GlobalHashScroll.js';

function Shell() {
  return (
    <Router>
      <GlobalRouteHighlighter />
      <Root />
    </Router>
  );
}

function App({ msalInstance }) {
  const clientId = localStorage.getItem('clientId');

  return clientId ? (
    <Shell />
  ) : (
    <MsalProvider instance={msalInstance}>
      <AuthProvider>
        <Shell />
      </AuthProvider>
    </MsalProvider>
  );
}

export default App;
